import { AxiosError } from 'axios'

import { httpClient } from 'shared/lib'
import consoleMessage from 'shared/utils/helpers/consoleMessage'

import isAxiosError from 'shared/utils/helpers/isAxiosError'
import { GetOrdersResult, SearchOrdersHistoryPayload } from './types'

function generateUrl(
   page: number,
   pageSize: number,
   fromDate: string,
   toDate: string,
   searchPhrase?: string,
   filterStatuses?: PropType<OrderType, 'status'>[],
   sortField?: PropType<SearchOrdersHistoryPayload, 'sortField'>,
   sortOrder?: PropType<SearchOrdersHistoryPayload, 'sortOrder'>
) {
   const searchParams = new URLSearchParams()

   searchParams.append('page', page.toString())
   searchParams.append('pageSize', pageSize.toString())
   searchParams.append('fromDate', fromDate)
   searchParams.append('toDate', toDate)
   if (searchPhrase) {
      searchParams.append('search', searchPhrase)
   }
   if (sortField) {
      searchParams.append('sortField', sortField)
   }
   if (sortOrder) {
      searchParams.append('sortOrder', sortOrder)
   }
   if (filterStatuses) {
      searchParams.append('status', filterStatuses.join(','))
   }

   return `orders/?${searchParams.toString()}`
}

export function getOrdersService(
   page: number,
   pageSize: number,
   fromDate: string,
   toDate: string,
   searchPhrase?: string,
   filterStatuses?: PropType<OrderType, 'status'>[],
   sortField?: PropType<SearchOrdersHistoryPayload, 'sortField'>,
   sortOrder?: PropType<SearchOrdersHistoryPayload, 'sortOrder'>
) {
   const url = generateUrl(page, pageSize, fromDate, toDate, searchPhrase, filterStatuses, sortField, sortOrder)
   let errMessage = ''

   return httpClient
      .get<GetOrdersResult>(url)
      .then((res) => {
         if (res.data) {
            return {
               data: res.data.orders.filter((item) => item.grossValueSum !== 0),
               totalElements: res.data.totalElements,
            }
         }
         throw new Error('noData')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage =
               `status: ${error.response?.status},url: ${error.response?.config.url}, message:${error.response?.data?.errors[0].defaultMessage}` ||
               'Unexpected error'
         } else {
            errMessage = error.message
         }
         consoleMessage('ORDERS HISTORY getOrders service', errMessage, 'error')
         throw new Error(errMessage)
      })
}

export function changeOrderNameService(orderName: string, orderUuid: string) {
   let errMessage = ''

   return httpClient
      .patch(`orders/${orderUuid}`, {
         cartName: orderName,
      })
      .then((res) => ({ status: res.status }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('ORDERS HISTORY changeOrderName service', errMessage, 'error')
         throw error
      })
}
